/**
 * @file: app-info.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import versionInfo from '@euler/config/version.json';
import packageInfo from '../../package.json';

export { versionInfo, packageInfo };

export const kAppVersion = packageInfo.version;
export const kAppVersionCode = versionInfo.code;
export const kAppVersionHash = versionInfo.current;
